import { ExternalTvConfig } from '@tivio/sdk-react'
import React, { createContext, PropsWithChildren, useRef } from 'react'

import { appConfig } from '../../static/appConfig'
import { useCustomer } from '../hooks/useCustomer'


type AppConfigValue = {
    config: ExternalTvConfig | null
}

const AppConfigContext = createContext<AppConfigValue>({
    config: null,
})

/**
 * Using app config (eg. logos, theming) based on customer value in CustomerProvider
 * @param props
 * @constructor
 */
const ConfigProvider: React.FC<PropsWithChildren> = (props) => {
    const customer = useCustomer()
    const config = useRef(appConfig[customer]).current

    if (!config) {
        throw new Error(`Tv config for customer ${customer} does not exist`)
    }

    return (
        <AppConfigContext.Provider value={{ config }}>
            {props.children}
        </AppConfigContext.Provider>
    )
}

export {
    ConfigProvider,
    AppConfigContext,
}
